export default __webpack_public_path__ + "static/media/logo.a6b26f41.png";